import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=68a9908e"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"
import style0 from "./carousel.vue?vue&type=style&index=0&id=68a9908e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports